document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const tryToAttachListener = () => {
    const mobileVideoArray = document.querySelectorAll('video-media.mobile-video video');
    const desktopVideoArray = document.querySelectorAll('video-media video');

    if (isMobile) {
      const video1 = mobileVideoArray[0];
      const playButton2 = document.querySelectorAll('video-media.mobile-video .deferred-poster')[1];
      const container1 = document.querySelectorAll('video-media.mobile-video')[0];
      const container2 = document.querySelectorAll('video-media.mobile-video')[1];

      customFunction(video1, playButton2, container1, container2);
    } else {
      const video1 = desktopVideoArray[0];
      const playButton2 = document.querySelectorAll('video-media:not(.mobile-video) .deferred-poster')[1];
      const container1 = document.querySelectorAll('video-media:not(.mobile-video)')[0];
      const container2 = document.querySelectorAll('video-media:not(.mobile-video)')[1];

      customFunction(video1, playButton2, container1, container2);
    }
  };

  const fadeSwitch = (from, to, callback) => {
    from.classList.add('fading-out');
    setTimeout(() => {
      from.classList.remove('fading-out');
      from.classList.add('hidden');
      to.classList.remove('hidden');
      to.classList.add('show');
      callback?.();
    }, 500); // Match CSS transition duration
  };

  const customFunction = (video1, playButton2, container1, container2) => {
    if (video1 && playButton2 && container1 && container2) {
      container1.classList.remove('hidden');
      container2.classList.add('hidden');

      video1.addEventListener('ended', () => {
        fadeSwitch(container1, container2, () => {
          playButton2.click();

          const checkVideo2 = setInterval(() => {
            const video2 = document.querySelectorAll('video')[1];
            if (video2) {
              clearInterval(checkVideo2);
              video2.play();

              video2.addEventListener('ended', () => {
                fadeSwitch(container2, container1, () => {
                  video1.currentTime = 0;
                  video1.play();
                });
              });
            }
          }, 100);
        });
      });
    } else {
      setTimeout(tryToAttachListener, 200);
    }
  };

  tryToAttachListener();
});